



const cache = new Map()
let timer





const getBBox = (el) => {
  if (!el || !('getBoundingClientRect' in el)) return null
  if (!cache.has(el)) {
    const {height, width, top, left} = el.getBoundingClientRect()
    cache.set(el, {height, width, top, left})
    if (!timer) {
      timer = window.setTimeout(() => {
        timer = undefined
        cache.clear()
      })
    }
  }
  return cache.get(el) || null
}

export default getBBox
